import React from 'react'
import { ColumnStartOrder, ColumnName, ColumnNoc, ColumnRank, ColumnResult, ColumnExtendedResult } from "components/common/TableColumns"
import Label from "components/general/Label"
import { ColumnRankRowSpan, ColumnRemarks, ColumnNocRowSpan, ColumnNameRowSpan, ColumnResultRowSpan, ColumnRemarksRowSpan, ColumnItemRowSpan, ColumnFencingColsSpan, ColumnExpanderRowSpan} from './TableColumns';

export function summaryColumns() {
    return [
        ColumnRank({disableSort: true , hasRankEqual: true}),
        ColumnNoc({disableSort: true}),
        ColumnName({disableSort: true}),
        ColumnExtendedResult({id:"Group", code:"GROUP", label:"HeaderSFL", headerClassname:'text-end w-10'}),
        ColumnResult({label:"HeaderTotalMpPoints", headerClassName: 'text-end w-10  mirs-break-line',}),
        ColumnRemarks({ headerClassName: 'text-end w-5 align-middle mirs-break-line'})
    ];
}

export function pointsColumns() {
    return [
        ColumnRankRowSpan({hasRankEqual: true}),
        ColumnNocRowSpan({}),
        ColumnNameRowSpan({}),
        ColumnItemRowSpan({section:"EQ", label:"HeaderRidingPoints", className: 'text-end', headerClassName: 'text-center w-5 mirs-break-line'}),
        ColumnFencingColsSpan({label:"HeaderFencingPoints", headerClassName:"text-center w-10 mirs-break-line" }),
        ColumnItemRowSpan({section:"SW", label:"HeaderSwimmingPoints", className: 'text-end', headerClassName: 'text-center w-5 mirs-break-line'}),
        ColumnItemRowSpan({section:"LR", label:"LaserRunPoints", className: 'text-end', headerClassName: 'text-center w-5 mirs-break-line'}),
        ColumnResultRowSpan({label:"HeaderTotalMpPoints2", headerClassName: 'text-end w-10 mirs-break-line'}),
        ColumnRemarksRowSpan({ headerClassName: 'text-center w-5 align-middle mirs-break-line', label: 'HeaderRemarks2'}),
        ColumnExpanderRowSpan({})
    ];
}
